module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_decollte_sola-c04f55d4a5e5d8aa6945f29e45a0ca10.svg";